import { createContext } from 'react';

let globalModalContext;

const ModalContext = createContext({
  setOpen: undefined,
  subscribe: undefined,
  unsubscribe: undefined,
});

/**
 * NON USARE
 * questo è un trucco per gestire le confirm che vengono lancitare "fuori" dal lifecycle di React
 * e non possono ereditare il contensto.
 */
ModalContext.setContext = (ctx) => { globalModalContext = ctx; };
ModalContext.getContext = () => globalModalContext;

ModalContext.setOpenOrGlobal = (open, setOpen, options) => {
  if (setOpen) {
    setOpen(open, options);
  } else if (globalModalContext && globalModalContext.setOpen) {
    globalModalContext.setOpen(open, options);
  }
};
ModalContext.subscribeOrGlobal = (subscribe, callback) => {
  if (subscribe) {
    subscribe(callback);
  } else if (globalModalContext && globalModalContext.subscribe) {
    globalModalContext.subscribe(callback);
  }
};
ModalContext.unsubscribeOrGlobal = (unsubscribe, callback) => {
  if (unsubscribe) {
    unsubscribe(callback);
  } else if (globalModalContext && globalModalContext.unsubscribe) {
    globalModalContext.unsubscribe(callback);
  }
};

export default ModalContext;
